module.exports = __webpack_public_path__ + "static/img/declaration-cn-card.77c623bf.svg";